import { useMutation } from '@tanstack/react-query'
import { createCallable } from 'react-call'

import { AlertDialog } from '@/components/ui/alert-dialog'
import { ButtonLoading } from '@/components/ui/button'

interface Props {
  title?: string
  message?: string
  confirmProcess?: () => Promise<any>
}

type Response = boolean

export const DialogCallable = createCallable<Props, Response>(function Render(props) {
  const {
    call,
    title = 'Apakah anda yakin?',
    message = 'Proses ini tidak dapat dibatalkan',
    confirmProcess,
  } = props

  const { mutateAsync, isPending } = useMutation({
    mutationFn: confirmProcess,
    onSuccess: () => call.end(true),
  })

  return (
    <AlertDialog
      open={!call.ended}
      onOpenChange={v => {
        if (v || isPending) return
        call.end(false)
      }}
    >
      <AlertDialog.Content>
        <AlertDialog.Header>
          <AlertDialog.Title>{title}</AlertDialog.Title>
          <AlertDialog.Description>{message}</AlertDialog.Description>
        </AlertDialog.Header>
        <AlertDialog.Footer>
          <ButtonLoading
            type='button'
            variant='destructive'
            onClick={() => mutateAsync()}
            isLoading={isPending}
          >
            Yes, I'm sure
          </ButtonLoading>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialog>
  )
}, 210)
